import React from "react";
import PropTypes from "prop-types";
import { Modal2 } from "@qgiv/core-donor";
import { useDispatch } from "react-redux";
import "./ProductModalContent.scss";
import ConnectedProductDetails from "../ProductDetails/ConnectedProductDetails";

const ProductModalContent = ({
    productModalOpen,
    currentProductId = "",
    setProductModalOpen,
}) => {
    const dispatch = useDispatch();
    const handleProductModalCloseClick = () => {
        dispatch(
            setProductModalOpen({
                productModalOpen: false,
                currentProductId: 0,
                modalAccessedFromStoreList: false,
            }),
        );
    };

    return (
        productModalOpen && (
            <Modal2 onClose={handleProductModalCloseClick} scrollOverflow>
                <div className="product-modal-content">
                    <ConnectedProductDetails productId={currentProductId} />
                </div>
            </Modal2>
        )
    );
};

ProductModalContent.propTypes = {
    currentProductId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    productModalOpen: PropTypes.bool.isRequired,
    setProductModalOpen: PropTypes.func.isRequired,
};

export default ProductModalContent;
